import { useMemo } from 'react';
import * as pas from 'js/hooks/auth/pas';

export const usePASPublicAPI = () => {
    return useMemo(() => ({
        /**
         * Low leven method to access forgot password functionality of Playtech Authentication Service (PAS) API.
         * @memberOf Playtech.API.pas
         * @function forgotPassword
         * @param {Object} options
         * @param {string} [options.userName]
         * @param {string} [options.email]
         * @param {string} [options.birthDate]
         * @param {string} [options.verificationAnswer]
         * @param {string} options.passwordRecoveryDestinationLink
         * @param {string} [options.notificationChannels]
         * @returns {Promise}
         * @example
         * Playtech.API.pas.forgotPassword({
         *  userName: 'test',
         *  email: 'test@playtech.com',
         *  birthDate: '2012-12-12',
         *  verificationAnswer: 'test',
         *  passwordRecoveryDestinationLink: 'https://www.playtech.com',
         *  notificationChannels: 'SMS,email'
         * });
         */
        forgotPassword: pas.forgotPassword
    }), []);
};
